// src/pages/Blog.js
import React from 'react';
import { Link } from 'react-router-dom';
import MainNavbar from '../components/MainNavbar';
import MainFooter from '../components/MainFooter';
import blogPosts from '../data/blogData';

const Blog = () => {
  return (
    <div className="font-sans antialiased text-gray-900">
      {/* Navbar */}
      <MainNavbar activePage="blog" />
      
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">The Dessino Blog</h1>
          <p className="text-xl mb-4 max-w-2xl mx-auto">
            Tips, tutorials, and insights about AI-powered prototyping and efficient design workflows
          </p>
        </div>
      </section>
      
      {/* Blog Posts */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4">
          {/* Featured Post - First post is featured */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8">Featured Article</h2>
            <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col md:flex-row">
              <div className="md:w-1/2 relative overflow-hidden">
                <img 
                  src={blogPosts[0].image} 
                  alt={blogPosts[0].title}
                  className="w-full h-64 md:h-full object-cover hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                    {blogPosts[0].category}
                  </span>
                </div>
              </div>
              <div className="p-6 md:w-1/2">
                <h3 className="text-2xl font-bold mb-3">
                  <Link to={`/blog/${blogPosts[0].slug}`} className="hover:text-orange-500 transition-colors">
                    {blogPosts[0].title}
                  </Link>
                </h3>
                <div className="text-sm text-gray-500 mb-4">
                  <span>{blogPosts[0].date}</span>
                </div>
                <p className="text-gray-600 mb-4">
                  {blogPosts[0].excerpt}
                </p>
                <Link 
                  to={`/blog/${blogPosts[0].slug}`}
                  className="text-orange-500 font-medium hover:text-orange-600 inline-flex items-center"
                >
                  Read More
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          {/* All Posts - Grid layout */}
          <h2 className="text-3xl font-bold mb-8">Latest Articles</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.slice(1).map((post) => (
              <article key={post.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="relative overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-gray-100 text-gray-800 text-xs px-3 py-1 rounded-full">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">
                    <Link to={`/blog/${post.slug}`} className="hover:text-orange-500 transition-colors">
                      {post.title}
                    </Link>
                  </h3>
                  <div className="text-xs text-gray-500 mb-3">
                    <span>{post.date}</span>
                  </div>
                  <p className="text-gray-600 text-sm mb-4">
                    {post.excerpt}
                  </p>
                  <Link 
                    to={`/blog/${post.slug}`}
                    className="text-orange-500 text-sm font-medium hover:text-orange-600 inline-flex items-center"
                  >
                    Read Article
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Transform Your Design Process?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Get started with Dessino.ai today and create interactive prototypes in minutes.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/signup" className="px-8 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors">
              Start Free Trial
            </Link>
            <Link to="/features" className="px-8 py-3 bg-white text-gray-800 rounded-lg hover:bg-gray-100 transition-colors border border-gray-300">
              Learn More
            </Link>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <MainFooter />
    </div>
  );
};

export default Blog;